import React, { useState, useEffect } from 'react';
import Navigation from '../components/Navigation';
import Hero from '../components/Hero';
import About from '../components/About';
import Skills from '../components/Skills';
import Experience from '../components/Experience';
import Projects from '../components/Projects';
import Movement from '../components/Movement';
import MediaProof from '../components/MediaProof';
import LandmarkEducation from '../components/LandmarkEducation';
import Legacy from '../components/Legacy';
import MediaGallery from '../components/MediaGallery';
import SocialHub from '../components/SocialHub';
import ToolsForTransformation from '../components/ToolsForTransformation';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Portfolio = () => {
  const [activeSection, setActiveSection] = useState('hero');

  useEffect(() => {
    const handleScroll = () => {
      const sections = ['hero', 'about', 'skills', 'experience', 'projects', 'movement', 'landmark', 'legacy', 'media', 'social', 'tools', 'contact'];
      const scrollPosition = window.scrollY + 100;

      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="portfolio-container">
      <Navigation activeSection={activeSection} />
      <Hero />
      <About />
      <Experience />
      <Skills />
      <LandmarkEducation />
      <Legacy />
      <MediaGallery />
      <SocialHub />
      <ToolsForTransformation />
      <Contact />
      <Footer />
    </div>
  );
};

export default Portfolio;
